import axios from "axios";
import { snackbarRef } from "./snackbarRef";

const url = process.env.REACT_APP_PATH;

console.log("Axios URL : " + url);

const instance = axios.create({
  baseURL: url,
  timeout: 10000,
});
instance.interceptors.response.use(
  (response) => response,
  (error) => {

    if (error.response) {
        const status = error.response.status;
        if (status === 401) {
        if (window.location.pathname !== "/signin") {
          window.location.href = "/signin";
        }
        return Promise.reject(error);
      }
      const message = error.response.data?.message || "Something went wrong";
      snackbarRef.current?.enqueueSnackbar(message, { variant: "error", });
    }
    return Promise.reject(error);
  }
);

export default instance;